export default {
  filterData : {
    Products: {
      label: '제품',
      allFilterLabel: "모든 제품",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "주제",
      allFilterLabel: "모든 주제",
      items: [
        { name: "액세스 관리", id: "Access management" },
        { name: "분석 및 모니터링", id: "Analytics and monitoring" },
        { name: "애플리케이션 딜리버리 및 보안", id: "Application delivery and security" },
        { name: "Citrix 및 Google", id: "Citrix and Google" },
        { name: "Citrix와 Microsoft", id: "Citrix and Microsoft" },
        { name: "클라우드 마이그레이션", id: "Cloud migration" },
        { name: "비교", id: "Compare" },
        { name: "Content collaboration", id: "Content collaboration" },
        { name: "디지털 워크스페이스", id: "Digital workspaces" },
        { name: "직원 경험", id: "Employee experience" },
        { name: "하이브리드 클라우드", id: "Hybrid cloud" },
        { name: "하이브리드 작업", id: "Hybrid work" },
        { name: "관리 및 최적화", id: "Manage and optimize" },
        { name: "마이크로서비스 및 devOps", id: "Microservices and devOps" },
        { name: "온보딩 및 채택", id: "Onboarding and adoption" },
        { name: "파트너 통합", id: "Partner integrations" },
        { name: "제품 개요", id: "Product overview" },
        { name: "보안 및 규제 준수", id: "Security and compliance" },
        { name: "소기업", id: "Small business" },
        { name: "사양", id: "Specifications" },
        { name: "지속성", id: "Sustainability" },
        { name: "통합 엔드포인트 관리", id: "Unified endpoint management" },
        { name: "VDI와 DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: '유형',
      allFilterLabel: "모든 유형",
      items: [
        { name: "분석 보고서", id: "Analyst report" },
        { name: "평가 도구", id: "Assessment tool" },
        { name: "고객 사례", id: "Customer story" },
        { name: "데이터시트", id: "Data sheet" },
        { name: "데모", id: "Demo" },
        { name: "eBook", id: "eBook" },
        { name: "안내", id: "Guide" },
        { name: "인포그래픽", id: "Infographic" },
        { name: "인터랙티브 투어", id: "Interactive tour" },
        { name: "팟캐스트", id: "Podcast" },
        { name: "자료 도구", id: "Resource kit" },
        { name: "솔루션 브리핑", id: "Solution brief" },
        { name: "기술 브리핑", id: "Technical brief" },
        { name: "동영상", id: "Video" },
        { name: "웨비나", id: "Webinar" },
        { name: "백서", id: "White paper" },
      ],
    },
    Industry: {
      label: "업계",
      allFilterLabel: "모든 업계",
      items: [
        { name: "교육", id: "education" },
        { name: "금융 서비스", id: "financial_service" },
        { name: "공공", id: "government" },
        { name: "의료", id: "healthcare" },
        { name: "제조", id: "manufacturing" },
        { name: "소매", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "검색 라이브러리",
    titles : {
      label1: "현재 동향",
      label2: "최신 자료",
      label3: "최근 조회",
      label4: "추천 자료"
    },
    showMoreLabel: "자세히 보기",
    clearAllSelected: "모든 선택 사항 지우기",
    searchResults: "결과 검색",
    clearAllFilters: "모든 필터 지우기",
    noResultsFound: "선택한 기준에 맞는 자산이 없음",
    resetView: "보기 초기화",
    filterLabel: "필터",
    filteredRes: "필터링된 결과",
    filterRes: "결과 필터링",
    clearAllCta: "모두 지우기",
    applyCta: "적용",
    view: "보기",
    includeEnglishRes: "영문 자료 포함"
  };